import { useCallback, useState } from 'react'

import { getAllClientDevice, getClientDevice } from '@/apis/clientDevice'
import { API_LIMIT } from '@/constants/api'
import useQueryPage from '@/hooks/useQueryPage'
import {
  GetAllClientDeviceResponse,
  GetOneClientDeviceRequest,
  GetOneClientDeviceResponse,
} from '@/types/apis/clientDevice'

export const useClient = () => {
  const currentPage = useQueryPage()
  const [page, setPage] = useState(currentPage)

  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<GetAllClientDeviceResponse>()
  const [deviceDetailResponse, setDeviceDetailResponse] = useState<GetOneClientDeviceResponse>()
  const [loadingDetail, setLoadingDetail] = useState(false)

  const get = useCallback(async () => {
    try {
      setLoading(true)
      const res = await getAllClientDevice()
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  const getDeviceDetail = useCallback(
    async (id: number, request: GetOneClientDeviceRequest) => {
      try {
        setLoadingDetail(true)
        const res = await getClientDevice(id, { page, limit: API_LIMIT, date: request.date })
        setDeviceDetailResponse(res)
      } finally {
        setLoadingDetail(false)
      }
    },
    [page]
  )

  return {
    loading,
    getClients: get,
    response,
    getDeviceDetail,
    deviceDetailResponse,
    loadingDetail,
    page,
    pageSize: API_LIMIT,
    setPage,
  }
}
